import React from 'react';
import styled from 'styled-components';
import projectImage1 from '../assets/project1.jpg';
import projectImage2 from '../assets/project2.jpg';
import projectImage3 from '../assets/project3.jpg';

const projects = [
  {
    title: 'Projeto Residencial',
    description: 'Sistemas fotovoltaicos para economia consistente e conforto sustentável.',
    location: 'Fortaleza - CE',
    tag: 'Residencial',
    image: projectImage1,
  },
  {
    title: 'Projeto Comercial',
    description: 'Instalações sob medida para negócios que buscam eficiência energética.',
    location: 'Região Metropolitana',
    tag: 'Comercial',
    image: projectImage2,
  },
  {
    title: 'Projeto Industrial',
    description: 'Soluções escaláveis para alto consumo e redução de custos operacionais.',
    location: 'Complexo Industrial',
    tag: 'Industrial',
    image: projectImage3,
  },
];

const Projects = () => {
  return (
    <ProjectsContainer>
      <Header>
        <Eyebrow>Projetos realizados</Eyebrow>
        <SectionTitle>Resultados reais em energia solar</SectionTitle>
        <SectionSubtitle>
          Cada projeto é pensado para entregar performance, economia e segurança energética para nossos clientes.
        </SectionSubtitle>
      </Header>
      <ProjectsGrid>
        {projects.map((project, index) => (
          <ProjectCard key={index}>
            <ProjectMedia>
              <ProjectImage src={project.image} alt={project.title} />
              <ProjectTag>{project.tag}</ProjectTag>
            </ProjectMedia>
            <ProjectContent>
              <ProjectTitle>{project.title}</ProjectTitle>
              <ProjectLocation>{project.location}</ProjectLocation>
              <ProjectDescription>{project.description}</ProjectDescription>
              <ProjectLink href="/contact">Quero um projeto assim</ProjectLink>
            </ProjectContent>
          </ProjectCard>
        ))}
      </ProjectsGrid>
    </ProjectsContainer>
  );
};

export default Projects;

// Styled Components

const ProjectsContainer = styled.div`
  padding: 48px 24px 80px;
  background: radial-gradient(circle at top, rgba(255, 69, 0, 0.12), transparent 55%),
    ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  text-align: left;

  @media (min-width: 900px) {
    padding: 80px 32px 120px;
  }
`;

const Header = styled.div`
  max-width: 820px;
  margin: 0 auto 40px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Eyebrow = styled.span`
  display: inline-flex;
  width: fit-content;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(255, 69, 0, 0.18);
  color: ${({ theme }) => theme.colors.primary};
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 600;
`;

const SectionTitle = styled.h2`
  font-size: clamp(2rem, 4vw, 2.8rem);
  color: ${({ theme }) => theme.colors.primary};
  margin: 0;
`;

const SectionSubtitle = styled.p`
  font-size: 1.05rem;
  color: ${({ theme }) => theme.colors.secondaryText};
  line-height: 1.6;
  margin: 0;
`;

const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 24px;
`;

const ProjectCard = styled.div`
  background-color: rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.35);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

const ProjectMedia = styled.div`
  position: relative;
  overflow: hidden;
`;

const ProjectImage = styled.img`
  width: 100%;
  height: 220px;
  object-fit: cover;
  transition: transform 0.4s ease;

  ${ProjectCard}:hover & {
    transform: scale(1.05);
  }
`;

const ProjectTag = styled.span`
  position: absolute;
  top: 16px;
  left: 16px;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(11, 15, 26, 0.85);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
`;

const ProjectContent = styled.div`
  padding: 22px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ProjectTitle = styled.h3`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0;
`;

const ProjectLocation = styled.span`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.secondaryText};
`;

const ProjectDescription = styled.p`
  font-size: 0.95rem;
  color: ${({ theme }) => theme.colors.secondaryText};
  margin: 0;
  line-height: 1.6;
`;

const ProjectLink = styled.a`
  margin-top: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.text};
  text-decoration: none;
  font-weight: 600;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 24px rgba(255, 199, 0, 0.3);
  }
`;
